import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { InView } from 'react-intersection-observer';

const PlayImage = (props) => {
    const {
        src,
        srcSet,
        sizes,
        alt = '',
        className,
        fallbackSrc /* eslint-disable-line */,
        height,
        width,
        imageRatio = '16-9',
        usePlaceholder = true,
        containerClassName,
        ssr,
        source = null,
        children,
        disableLazyload,
        ...rest
    } = props;

    //TODO: use browser built in support
    //const supportsLazyLoading = isBrowser() && Modernizr.lazyload;

    const imgClasses = classNames(className, 'play_image play_image--loaded');
    const containerClasses = classNames(
        'play_image-container',
        `play_image-container--${imageRatio}`,
        containerClassName
    );

    if (usePlaceholder) {
        if (ssr || disableLazyload) {
            return (
                <div className={containerClasses}>
                    {children}
                    <picture>
                        {source}
                        <img
                            loading="lazy"
                            className={imgClasses}
                            width={width}
                            height={height}
                            src={src}
                            srcSet={srcSet}
                            sizes={sizes}
                            alt={alt}
                            {...rest}
                        />
                    </picture>
                </div>
            );
        }

        return (
            <InView rootMargin="200px 0px" triggerOnce>
                {({ inView, ref }) => (
                    <div ref={ref} className={containerClasses}>
                        {children}
                        <picture>
                            {source}
                            <img
                                className={classNames(className, 'play_image', {
                                    'play_image--loaded': inView || ssr,
                                })}
                                width={width}
                                height={height}
                                data-src={src}
                                src={inView || ssr ? src : null}
                                srcSet={inView || ssr ? srcSet : null}
                                sizes={sizes}
                                alt={inView || ssr ? alt : ''}
                                {...rest}
                            />
                        </picture>
                    </div>
                )}
            </InView>
        );
    }

    //chrome will handle lazy loading if supported (v76+)
    return (
        <picture>
            {source}
            <img
                loading="lazy"
                className={imgClasses}
                width={width}
                height={height}
                src={src}
                srcSet={srcSet}
                sizes={sizes}
                alt={alt}
                {...rest}
            />
        </picture>
    );
};

PlayImage.propTypes = {
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    imageRatio: PropTypes.oneOf(['16-9', 'cinema', 'square', 'imax', '2-3']),
    usePlaceholder: PropTypes.bool,
    ssr: PropTypes.bool,
    source: PropTypes.element,
};

PlayImage.defaultProps = {
    alt: '',
    imageRatio: '16-9',
    usePlaceholder: true,
    source: null,
};

export default PlayImage;
